import { toast } from "react-toastify";

export const showToast = (message, type = "error") => {
  const toastConfig = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    icon: false,
    closeButton: (
      <button
        className="text-black"
        onClick={() => toast.dismiss()}
        style={{
          backgroundColor: "transparent",
          border: "none",
          marginBottom: "2.813rem",
        }}
      >
        ✖
      </button>
    ),
    className: `toast-${type} z-[10] text-md rounded text-black`,
  };

  const content = (
    <div className="flex z-[10] items-center">
      <div className="mr-3 flex-shrink-0">
        {type=="error"&&<img src="/tick-error.svg" alt="Error Icon" className="h-6 w-6" />}
        {type!="error"&&<img src="/tick-circle.svg" alt="success Icon" className="h-6 w-6" />}

      </div>
      <div>
        <h3 className="font-semibold text-md text-black">
          {type === "success" ? "Successful!" : "Error!"}
        </h3>
        <p className="text-sm text-black">{message}</p>
      </div>
    </div>
  );

  if (type === "success") {
    toast.success(content, toastConfig);
  } else {
    toast.error(content, toastConfig);
  }
};
